import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de.json";
import en from "./locales/en.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            de: { translation: de },
            en: { translation: en },
        },
        fallbackLng: "de",
        supportedLngs: ["de", "en"],
        interpolation: { escapeValue: false },
        detection: {
            // Jul-2026 (User-Wunsch): Deutsch ist fester Standard — die Browser-
            // Sprache wird NICHT mehr ausgewertet. Englisch nur bei bewusster
            // Wahl über den Sprachumschalter (localStorage tw_lang).
            order: ["localStorage"],
            caches: ["localStorage"],
            lookupLocalStorage: "tw_lang",
        },
    });

export default i18n;
